import { render, staticRenderFns } from "./WebItem.vue?vue&type=template&id=2c22961e&scoped=true"
import script from "./WebItem.vue?vue&type=script&lang=js"
export * from "./WebItem.vue?vue&type=script&lang=js"
import style0 from "./WebItem.vue?vue&type=style&index=0&id=2c22961e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ckru7f3yypsoan6edyu23zfbiq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22961e",
  null
  
)

export default component.exports